import Vue from 'vue'
import VueRouter from 'vue-router'

//about
import Intro from './views/Intro'

import Org from './views/Org'
import Frame from './views/subViews/org/Frame'
import Leader from './views/subViews/org/Leader'

import Business from './views/Business'
import Honor from './views/Honor'
import Culture from './views/Culture'
import Branch from './views/Branch'
//culture
import Slogan from './views/subViews/culture/Slogan'
import Staff from './views/subViews/culture/Staff'
import Office from './views/subViews/culture/Office'
import video from './views/subViews/culture/Video'
//branch
import Singapore from './views/subViews/branch/Singapore'
import Maritime from './views/subViews/branch/Maritime'
import Equip from './views/subViews/branch/Equip'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/intro' },
    { path: '/intro', name:'intro', component: Intro },
    { path: '/org', name:'org', component: Org ,
      children: [
        { path: '/org', redirect:'/org/frame'},
        { path: 'frame', name: 'frame', component: Frame },
        { path: 'leader', name: 'leader', component: Leader }
      ]
    },
    { path: '/business', name:'business', component: Business },
    { path: '/honor', name:'honor', component: Honor },
    { path: '/culture', name:'culture', component: Culture,
      children: [
        { path: '/culture', redirect:'/culture/slogan'},
        { path: 'slogan', name: 'slogan', component: Slogan },
        { path: 'staff', name: 'staff', component: Staff },
        { path: 'office', name: 'office', component: Office },
        { path: 'video', name: 'video', component: video }
      ]
    },
    { path: '/branch', name:'branch', component: Branch,
      children: [
        { path: '/branch', redirect:'/branch/singapore'},
        { path: 'singapore', name: 'singapore', component: Singapore },
        { path: 'maritime', name: 'maritime', component: Maritime },
        { path: 'equip', name: 'equip', component: Equip }
      ]
    }
  ]
});

// 全局前置守卫
router.beforeEach((to, from, next) => { next(); });

// 全局后置
router.afterEach(() => {});

export default router
